module.exports = __webpack_public_path__ + "static/media/icon-log.d0a0e03e.png";